import { Locale } from '../../lib/types/types';
import { logger } from '../utils/logger/logger';

export enum VerificationStepsEnum {
    collectStudentPersonalInfo = 'collectStudentPersonalInfo',
    collectTeacherPersonalInfo = 'collectTeacherPersonalInfo',
    collectMilitaryStatus = 'collectMilitaryStatus',
    collectActiveMilitaryPersonalInfo = 'collectActiveMilitaryPersonalInfo',
    collectInactiveMilitaryPersonalInfo = 'collectInactiveMilitaryPersonalInfo',
    collectSeniorPersonalInfo = 'collectSeniorPersonalInfo',
    collectFirstResponderPersonalInfo = 'collectFirstResponderPersonalInfo',
    collectMedicalProfessionalPersonalInfo = 'collectMedicalProfessionalPersonalInfo',
    collectEmployeePersonalInfo = 'collectEmployeePersonalInfo',
    docUpload = 'docUpload',
    pending = 'pending',
    docReviewLimitExceeded = 'docReviewLimitExceeded',
    success = 'success',
    error = 'error',
    sso = 'sso',
}
export const VerificationSteps = (<any>Object).values(VerificationStepsEnum); // For runtime checks


export enum TryAgainStepsEnum {
    docUpload = 'docUpload',
    pending = 'pending',
    error = 'error',
}
export const TryAgainSteps = (<any>Object).values(TryAgainStepsEnum); // For runtime checks


export enum MockStepsEnum {
    loading = 'loading',
}

export const MockSteps = [
    ...(<any>Object).values(VerificationStepsEnum),
    ...(<any>Object).values(MockStepsEnum),
];


export enum SegmentEnum {
    STUDENT = 'student',
    MILITARY = 'military',
    TEACHER = 'teacher',
    SENIOR = 'senior',
    FIRST_RESPONDER = 'firstResponder',
    MEDICAL = 'medical',
    EMPLOYMENT = 'employment',
}
export const Segments = (<any>Object).values(SegmentEnum); // For runtime checks


export enum SubSegmentEnum {
    ACTIVE_DUTY = 'activeDuty',
    VETERAN = 'veteran',
    RESERVIST = 'reservist',
    MILITARY_RETIREE = 'retiree',
    MILITARY_FAMILY = 'militaryFamily',
    FIREFIGHTER = 'fireFighter',
    POLICE = 'police',
    EMT = 'emt',
    NURSE = 'nurse',
}
export const SubSegments = (<any>Object).values(SubSegmentEnum); // For runtime checks

export enum MilitaryStatusDefaultMessagesEnum {
    ACTIVE_DUTY = 'Active Duty',
    MILITARY_RETIREE = 'Military Retiree',
    RESERVIST = 'Reservist',
    VETERAN = 'Veteran',
    MILITARY_FAMILY = 'Registered Military Dependent',
}

export enum FirstResponderStatusDefaultMessagesEnum {
    FIREFIGHTER = 'Firefighter',
    POLICE = 'Police',
    EMT = 'EMT',
}

export enum MedicalProfessionalStatusDefaultMessagesEnum {
    NURSE = 'Nurse',
    DOCTOR = 'Doctor',
}

export const MilitaryStatusDefaultMessages = (<any>Object).values(MilitaryStatusDefaultMessagesEnum); // For runtime checks
export const FirstResponderStatusDefaultMessages = (<any>Object).values(FirstResponderStatusDefaultMessagesEnum); // For runtime checks
export const MedicalStatusdefaultMessages = (<any>Object).values(MedicalProfessionalStatusDefaultMessagesEnum); // For runtime checks


export enum FieldIdEnum {
    firstName = 'firstName',
    lastName = 'lastName',
    organization = 'organization',
    birthDate = 'birthDate',
    email = 'email',
    phoneNumber = 'phoneNumber',
    postalCode = 'postalCode',
    address1 = 'address1',
    city = 'city',
    state = 'state',
    dischargeDate = 'dischargeDate',
    docUpload = 'docUpload',
    status = 'status',
    marketConsentValue = 'marketConsentValue',
}
export const FieldIds = (<any>Object).values(FieldIdEnum); // For runtime checks

export enum HookNameEnum {
    ON_VERIFICATION_READY = 'ON_VERIFICATION_READY',
    ON_VERIFICATION_SUCCESS = 'ON_VERIFICATION_SUCCESS',
    ON_VERIFICATION_STEP_CHANGE = 'ON_VERIFICATION_STEP_CHANGE',
}
export const HookNames = (<any>Object).values(HookNameEnum);

/**
 * @description List of locales supported by the library, for runtime checks.
 */
export const Locales: Locale[] = ['en-US'];

/**
 * Add to the list of known locales for more helpful runtime checks.
 */
export const registerAdditionalLocales = (locales: Locale[]): void => {
    logger.info(`Registering additional locales ${locales.join(', ')}`);
    Locales.push(...locales);
};
